// "Upload to search" — the Browse reverse-image button, beside the search box.
//
// Picking a file and dropping one on the search row do the same thing; both call
// `runImageSearch` (./run), which owns the downscale → embed → store → re-search sequence.
import { useRef, useState } from "preact/hooks";
import { runImageSearch } from "./run";

export function SearchImageButton() {
  const [busy, setBusy] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);

  async function run(file: File): Promise<void> {
    setBusy(true);
    await runImageSearch(file);
    setBusy(false);
  }

  return (
    <span class="search-image">
      {/* The label does NOT change once an image is attached: the button's job is the same
          either way — pick a file — and the attached image is already reported by the
          sidebar chip, which is also where removing it lives.

          A real file input, kept out of the layout and clicked through the ref — a bare
          `document.createElement("input")` (what the checker modal does) is fine for a
          one-shot, but this one is re-used and needs its value cleared so picking the SAME
          file twice still fires `change`. */}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        class="search-image-file"
        onChange={(e) => {
          const input = e.currentTarget;
          const file = input.files?.[0];
          input.value = "";
          if (file) void run(file);
        }}
      />
      <span
        class={`button medium search-image-button${busy ? " search-image-busy" : ""}`}
        onClick={() => {
          if (!busy) inputRef.current?.click();
        }}
      >
        <i class={`fas fa-${busy ? "spinner fa-spin" : "image"}`} />{" "}
        {busy ? "Reading…" : "Upload to search"}
      </span>
    </span>
  );
}
